/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Ключевая фраза класса МКТУ (в контексте одного класса)
 * @export
 * @interface MktuKeyWord
 */
export interface MktuKeyWord {
  /**
   * UUID фразы
   * @type {string}
   * @memberof MktuKeyWord
   */
  uuid: string
  /**
   * Ключевая фраза класса МКТУ
   * @type {string}
   * @memberof MktuKeyWord
   */
  word: string
  /**
   * Относится ли фраза к международному справочнику Ниццы
   * @type {boolean}
   * @memberof MktuKeyWord
   */
  isNice: boolean
}

/**
 * Check if a given object implements the MktuKeyWord interface.
 */
export function instanceOfMktuKeyWord(value: object): value is MktuKeyWord {
  if (!('uuid' in value) || value['uuid'] === undefined) return false
  if (!('word' in value) || value['word'] === undefined) return false
  if (!('isNice' in value) || value['isNice'] === undefined) return false
  return true
}

export function MktuKeyWordFromJSON(json: any): MktuKeyWord {
  return MktuKeyWordFromJSONTyped(json, false)
}

export function MktuKeyWordFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MktuKeyWord {
  if (json == null) {
    return json
  }
  return {
    uuid: json['uuid'],
    word: json['word'],
    isNice: json['isNice'],
  }
}

export function MktuKeyWordToJSON(value?: MktuKeyWord | null): any {
  if (value == null) {
    return value
  }
  return {
    uuid: value['uuid'],
    word: value['word'],
    isNice: value['isNice'],
  }
}
